import React, { useState, useRef } from 'react';
import { useScrollFade } from '../hooks/useScrollFade';
export function TestimonialSection() {
  const {
    ref,
    isVisible
  } = useScrollFade();
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const testimonials = [{
    quote: 'My husband asked me what I was doing differently. I told him: nothing. My skin is just doing it on its own now.',
    author: 'Patient, Danville CA'
  }, {
    quote: "I didn't want to look 'done', I just wanted to look rested. Three sessions later, my jawline is back and my skin is glowing.",
    author: 'Patient, San Ramon CA'
  }, {
    quote: 'The texture of my skin has completely changed. My makeup goes on flawlessly, but honestly, I barely wear it anymore.',
    author: 'Patient, Walnut Creek CA'
  }];
  const handleScroll = () => {
    if (scrollContainerRef.current) {
      const scrollPosition = scrollContainerRef.current.scrollLeft;
      const itemWidth = scrollContainerRef.current.clientWidth;
      const newIndex = Math.round(scrollPosition / itemWidth);
      setActiveIndex(newIndex);
    }
  };
  const scrollTo = (index: number) => {
    if (scrollContainerRef.current) {
      const itemWidth = scrollContainerRef.current.clientWidth;
      scrollContainerRef.current.scrollTo({
        left: index * itemWidth,
        behavior: 'smooth'
      });
      setActiveIndex(index);
    }
  };
  return <section className="py-24 bg-warm-bg relative overflow-hidden" data-id="element-186">
      <div className="container mx-auto px-4 md:px-8 max-w-4xl" data-id="element-187">
        <div ref={ref} className={`relative transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-188">
          {/* Large decorative quote mark */}
          <div className="absolute -top-12 md:-top-16 left-1/2 -translate-x-1/2 text-gold/20 font-serif text-8xl md:text-9xl leading-none select-none" data-id="element-189">
            "
          </div>

          {/* Swipeable Container */}
          <div ref={scrollContainerRef} className="flex overflow-x-auto snap-x snap-mandatory hide-scrollbar relative z-10" onScroll={handleScroll} data-id="element-190">
            {testimonials.map((testimonial, index) => <div key={index} className="w-full flex-shrink-0 snap-center flex flex-col items-center text-center px-4" data-id="element-191">
                <blockquote className="font-serif italic text-2xl md:text-3xl lg:text-4xl text-text-dark leading-relaxed mb-8 max-w-3xl" data-id="element-192">
                  "{testimonial.quote}"
                </blockquote>
                <cite className="not-italic text-text-dark/60 text-sm md:text-base uppercase tracking-widest" data-id="element-193">
                  — {testimonial.author}
                </cite>
              </div>)}
          </div>

          {/* Dots Indicator */}
          <div className="flex justify-center gap-3 mt-12" data-id="element-194">
            {testimonials.map((_, index) => <button key={index} onClick={() => scrollTo(index)} aria-label={`Go to testimonial ${index + 1}`} className={`w-2 h-2 rounded-full transition-all duration-300 ${activeIndex === index ? 'bg-gold w-6' : 'bg-divider hover:bg-gold/50'}`} data-id="element-195" />)}
          </div>
        </div>
      </div>
    </section>;
}